import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { DatePipe, CurrencyPipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { provideAnimations, provideNoopAnimations } from '@angular/platform-browser/animations';
import { AuthModule, StsConfigLoader } from 'angular-auth-oidc-client';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { CUSTOM_FORMATS } from './core/custom-datepicker/custom-datepicker.component';
import { AgentConfirmationService } from './core/services/agent-confirmation.service';
import { AuthService } from './core/services/auth.service';
import { AuthGuardService } from './core/services/authguard.service';
import { ComponentService } from './core/services/component.service';
import { UiService } from './core/services/ui.service';
import { authFactory, OidcConfigService } from './shared/oidc.service';

    

    export const appConfig: ApplicationConfig = {
      providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes,
           withInMemoryScrolling({
        scrollPositionRestoration: 'top', // or 'enabled'
      })
        ),
        importProvidersFrom(BrowserModule, MatToolbarModule, MatIconModule, MatButtonModule, MatInputModule, ReactiveFormsModule, FormsModule, MatDatepickerModule, MatNativeDateModule, MatCheckboxModule, MatFormFieldModule, MatSelectModule, MatButtonToggleModule, MatCardModule, MatTooltipModule,  AutocompleteLibModule, MatMomentDateModule, 
          AuthModule.forRoot({
            loader: {
                provide: StsConfigLoader,
                useFactory: authFactory,
                deps: [OidcConfigService],
            },
        })),
        DatePipe, CurrencyPipe, AuthService, AuthGuardService, ComponentService, UiService, AgentConfirmationService,
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: CUSTOM_FORMATS },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi()),
        provideNoopAnimations(),
        provideClientHydration()
        // Add other root-level providers here, e.g., provideHttpClient(), provideAnimations(), etc.
      ]
    };